import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const FlameIcon = () => (
  <svg width="32" height="32" viewBox="0 0 36 36" fill="none">
    <defs>
      <linearGradient id="flameGradF" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F5A623"/>
        <stop offset="100%" stopColor="#E8531E"/>
      </linearGradient>
    </defs>
    <circle cx="18" cy="18" r="18" fill="url(#flameGradF)"/>
    <path d="M20 8c0 0-1 3-3 4.5C15 14 13 15 13 18c0 3 2.5 5.5 5 5.5s5-2.5 5-5.5c0-2-1-3-2-4 0 1.5-1 2.5-2 3 0-2 1-5 1-9z" fill="white" opacity="0.95"/>
    <circle cx="18" cy="21" r="2.5" fill="rgba(255,255,255,0.4)"/>
  </svg>
);

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.3.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M3.18 23.4c.3.16.63.19.96.07l13.5-7.79L3 7.8 2.82 21.7c-.01.67.12 1.36.36 1.7zm1.32-17.7L17.46 13 4.5 5.4V5.7zm14.1 6.9l-2.58-1.49-2.58 1.49 2.58 4.47 2.58-4.47z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <FlameIcon />
              <span>FlareChat</span>
            </Link>
            <p className="footer-tagline">
              Real-life plans, made easy.<br/>
              Shoot up a flare, see who's free.
            </p>
            <div className="footer-stores">
              <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer" className="footer-store">
                <AppleIcon /> App Store
              </a>
              <a href="https://play.google.com" target="_blank" rel="noopener noreferrer" className="footer-store">
                <PlayIcon /> Google Play
              </a>
            </div>
          </div>

          <div className="footer-links-group">
            <p className="footer-group-title">Navigate</p>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>

          <div className="footer-links-group">
            <p className="footer-group-title">Product</p>
            <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer">iOS App</a>
            <a href="https://play.google.com" target="_blank" rel="noopener noreferrer">Android App</a>
          </div>

          <div className="footer-links-group">
            <p className="footer-group-title">Contact</p>
            <a href="mailto:jim@getflarechat.com">jim@getflarechat.com</a>
            <span className="footer-location">📍 East Greenbush, NY</span>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 FlareChat LLC. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
